import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  isInContext,
  onComplete,
  closeWindow,
} from '../utility/inContextDonation';
import _get from 'lodash/get';
import ConfirmationReturnText from './ConfirmationReturnText';

function ConfirmationInContext(props) {
  useEffect(() => {
    if (isInContext()) {
      const postBackData = _get(props.postBackData, 'postBackData');
      onComplete(postBackData);
    }
  }, []);

  useEffect(() => {
    setTimeout(() => {
      closeWindow();
    }, 5000);
  }, []);

  return <ConfirmationReturnText returnText={props.returnText} />;
}

ConfirmationInContext.propTypes = {
  postBackData: PropTypes.object,
  returnText: PropTypes.string,
};

export default ConfirmationInContext;
